<template>
  <a-card :bordered='false'>

    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='8' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        size='middle'
        :columns='columns'
        :data-source='dataSource'
        :loading='loading'
        :pagination='false'
        bordered
        :row-class-name="getRowClassName"
        @change='handleTableChange'
      >
      </a-table>

    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getCollectionAvgTaskInfo } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import { REFUND_TRADE_STATUS } from '@/constants/status'
import moment from 'moment'
import exportFile from '@/webpublicapi/exportFile'

export default {
  name: 'AppList',
  components: {
    Dict
  },
  data() {
    return {
      visible: false,
      REFUND_TRADE_STATUS,
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      // 查询条件
      queryParam: {
      },
      loading: false,
      // 表头
      columns: [
        {
          title: '催收阶段',
          align: 'center',
          dataIndex: 'normalName'
        },
        {
          title: '用户类型',
          align: 'center',
          dataIndex: 'orderType'
        },
        {
          title: '总订单数',
          align: 'center',
          dataIndex: 'orderSum'
        },
        {
          title: '催收人数',
          align: 'center',
          dataIndex: 'collectorNum'
        },
        {
          title: '人均分单数量',
          align: 'center',
          dataIndex: 'perCapitaTask'
        }
      ],
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {
    getRowClassName(record) {
      if (!record || !record.orderType) {
        return ''
      }
      const type = record.orderType
      if (type === '小计') {
        return 'table-subtotal-row'
      }
      if (type === '合计') {
        return 'table-grandtotal-row'
      }
      return ''
    },
    //计算利率的方法,c为需要监控的项
    calculateRate(a, b, c) {
      if (a === 0 || b === 0) {
        return 0 + '%'
      } else if (b === 0) {
        return 0 + '%'
      } else {
        return (a / b * 100).toFixed(2) + '%'
      }
    },
    
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      if (params.appssidList !== undefined) {
        let arr = params.appssidList
        console.log('params.appssidList---->', params.appssidList)
        if (arr.includes('')) {
          delete params.appssidList
        }
      }
      console.log('params--->', params)
      console.log('params.appssidList--->', params.appssidList)
      getCollectionAvgTaskInfo(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })

      // 同时加载合计数据
      // this.loadSumData()
    },
    getQueryParams() {
      const { dataDt } = this.queryParam
      const data = {
        ...this.queryParam,
      }
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange(pagination, filters, sorter) {
      // TODO 筛选
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    handleAdd() {
      this.$refs.modalForm.add()
    },
    // model回调
    modalFormOk() {
      this.loadData()
    }

  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

::v-deep .table-subtotal-row {
  background-color: #fff7e6 !important;
  td {
    font-weight: bold;
  }
}

::v-deep .table-grandtotal-row {
  background-color: #ffe8e8 !important;
  td {
    font-weight: bold;
    color: #f5222d;
  }
}
</style>